import { appApiEndpoint } from "@/environment";
import { baseApi } from "./baseApi";

// Job Clips API slice - extends the base API
export const jobClipsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get paginated job clips
    getJobClips: builder.query({
      query: ({
        employerPermalink,
        perPage = 50,
        cursor = null,
        searchQuery = null,
        includedStates = null,
        isPrefetchQuery = false,
      }) => {
        let url = new URL(
          `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips`
        );
        let params = new URLSearchParams();
        params.append("perPage", perPage);

        if (cursor) {
          params.append("cursor", cursor);
        }
        if (searchQuery) {
          params.append("search", searchQuery);
        }
        if (includedStates && includedStates.length > 0) {
          includedStates.forEach((state) => {
            params.append("includedStates[]", state);
          });
        }

        url.search = params.toString();
        return {
          url: url.toString(),
          method: "GET",
          isPrefetchQuery,
        };
      },
      providesTags: ["JobClips"],
    }),

    // Get single job clip
    getJobClip: builder.query({
      query: ({ employerPermalink, jobClipPermalink }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips/${jobClipPermalink}`,
        method: "GET",
      }),
      providesTags: (result, error, { jobClipPermalink }) => [
        { type: "JobClips", id: jobClipPermalink },
      ],
    }),

    // Create job clip
    createJobClip: builder.mutation({
      query: ({ employerPermalink, jobClipData }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips`,
        method: "POST",
        data: jobClipData,
      }),
      invalidatesTags: ["JobClips"],
    }),

    // Update job clip
    updateJobClip: builder.mutation({
      query: ({ employerPermalink, jobClipPermalink, jobClipData }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips/${jobClipPermalink}`,
        method: "PUT",
        data: jobClipData,
      }),
      invalidatesTags: (result, error, { jobClipPermalink }) => [
        { type: "JobClips", id: jobClipPermalink },
        "JobClips",
      ],
    }),

    // Delete job clip
    deleteJobClip: builder.mutation({
      query: ({ employerPermalink, jobClipPermalink }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips/${jobClipPermalink}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { jobClipPermalink }) => [
        { type: "JobClips", id: jobClipPermalink },
        "JobClips",
      ],
    }),

    // Get job clip metrics
    getJobClipMetrics: builder.query({
      query: ({ employerPermalink, jobClipPermalink }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/job-clips/${jobClipPermalink}/metrics`,
        method: "GET",
      }),
      providesTags: (result, error, { jobClipPermalink }) => [
        { type: "JobClips", id: `${jobClipPermalink}-metrics` },
      ],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetJobClipsQuery,
  useGetJobClipQuery,
  useCreateJobClipMutation,
  useUpdateJobClipMutation,
  useDeleteJobClipMutation,
  useGetJobClipMetricsQuery,
} = jobClipsApi;
